module.exports = __webpack_public_path__ + "static/media/cohocton.6be09bde.png";